import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import CommonTable from "../../common-components/common-tables/CommonTable";
import { CallIcon, EmailIcon, PersonIcon } from "../../../images/icons/icons";
import { formatDateTime } from "../../common-data/Converts";
import { fetchTrainerStatsDetailsData } from "../../../redux/prospect-reducers/prospectSlice";

const TrainerStatsDetailTable = ({ userInfoData, rowData, filterType }) => {
  const dispatch = useDispatch();
  const {
    trainerStatsDetailsLoading,
    trainerStatsDetailsError,
    trainerStatsDetailsData,
  } = useSelector((state) => state.prospects);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    trainer_id: rowData?.trainer_id || "",
    filter_type: filterType || "",
  };
  const [filters, setFilters] = useState(iniFilters);

  const iniTbDatas = {
    pagination: [],
    allData: [],
  };
  const [allTbDatas, setAllTbDatas] = useState(iniTbDatas);

  function getTrainerStatsDetails(filters) {
    dispatch(
      fetchTrainerStatsDetailsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    if (rowData?.trainer_id && filterType) {
      getTrainerStatsDetails(filters);
    }
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    if (
      !trainerStatsDetailsLoading &&
      !trainerStatsDetailsError &&
      trainerStatsDetailsData?.status &&
      trainerStatsDetailsData?.data?.length > 0
    ) {
      setAllTbDatas((prevs) => ({
        ...prevs,
        allData: trainerStatsDetailsData.data,
        pagination:
          trainerStatsDetailsData?.pagination?.length > 0
            ? trainerStatsDetailsData.pagination
            : [],
      }));
    } else {
      setAllTbDatas(iniTbDatas);
    }
  }, [
    trainerStatsDetailsLoading,
    trainerStatsDetailsError,
    trainerStatsDetailsData,
  ]);

  const tbColumns = [
    {
      dataField: "member_name",
      text: "Member Info",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>
              <span className="tb-data">{row?.member_name || "NA"}</span>
            </div>

            {row?.member_mobile && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <CallIcon />
                </span>
                <span className="tb-data">{row.member_mobile}</span>
              </div>
            )}

            {row?.member_email && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <EmailIcon />
                </span>
                <span className="tb-data lowercase">
                  {row.member_email}
                </span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 45;

        return (
          <span className={`tb-data ${isLong ? "tb-data-long" : ""}`}>
            {gymName}
          </span>
        );
      },
    },
    {
      dataField: "subscription_id",
      text: "Subscription ID",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.subscription_id || "NA"}</span>;
      },
    },
    {
      dataField: "start_date",
      text: "Start Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.start_date ? formatDateTime(row.start_date, "date") : "-"}
          </span>
        );
      },
    },
    {
      dataField: "expire_date",
      text: "Expire Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.expire_date ? formatDateTime(row.expire_date, "date") : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <div className="common-table-container tb-bordered mt15">
      <CommonTable
        tableData={allTbDatas.allData}
        tablePagination={allTbDatas.pagination}
        tableColumns={tbColumns}
        isPage={isPage}
        setIsPage={setIsPage}
        pageLimit={pageLimit}
        setPageLimit={setPageLimit}
        isLoading={trainerStatsDetailsLoading}
      />
    </div>
  );
};

export default TrainerStatsDetailTable;
